import { observerEpicHelper } from 'epics/helpers'
import { Constants as AlgoliaActions, Actions as AlgoliaEventActions } from 'actions/algolia'
import {
  selectedFacetsToAlgoliaQueryString,
  selectedFacetsToAlgoliaEventFilter,
} from 'lib/algolia/v2'
import { algoliaCollectionApi, algoliaEventsApi } from 'apis/algolia'
import { getMeasurementUnit, getUserID } from 'selectors/user/session'
import { Actions as PageActions } from 'actions/page'
import { getUserPreferencesDestinationZone, getAlgoliaUserToken } from 'selectors/user/cookie'
import { applicationId, searchApi } from '../helpers/constants'
import { Constants } from '../actions'
import { setAlgoliaQueryIDInLocalStorage } from 'lib/algolia/v2/helpers'
import { getSortIndice } from '../selectors/algolia'
import { getCollectionId } from '../selectors/url'
import { getSelectedFacets } from '../selectors/facets'
import { getSearch } from '../selectors/app'
import url from 'url'

export const updateAlgoliaEpic = observerEpicHelper(
  [Constants.UPDATE_ALGOLIA],
  async ({ action, observer, store }) => {
    observer.next(PageActions.IS_READY(false))
    const algoliaObjectParams = action.payload ? action.payload : {}
    const href = algoliaObjectParams?.href || {}
    // Get Algolia Config Data: applicationId, searchApi, searchIndice
    // Update Sort
    const searchIndice = getSortIndice({ ...store.value })
    const { query: queryFromRef } = url.parse(href, true)
    const { hitsPerPage, page } = queryFromRef || {}
    const selectedFacets = getSelectedFacets({ ...store.value })
    const collectionId = getCollectionId({ ...store.value })
    const destinationZone = getUserPreferencesDestinationZone({ ...store.value })
    const query = getSearch({ ...store.value })
    const filters = selectedFacetsToAlgoliaQueryString(
      { ...selectedFacets, collection_id: collectionId }, // selected facets
      {
        measurementUnit: getMeasurementUnit({ ...store.value }),
        destinationZone,
      } // Additional params
    )
    const algoliaParams = {
      applicationId,
      searchApi,
      searchIndice,
      filters,
      query,
      ...algoliaObjectParams,
      hitsPerPage: hitsPerPage || 100,
      page: page || 0,
      destinationZone,
    }
    const algoliaResults = await algoliaCollectionApi(algoliaParams)
    observer.next(
      PageActions.SET_DATA({
        algoliaResults,
      })
    )
    const { queryID } = algoliaResults
    const userID = getUserID({ ...store.value })
    const eventFilters = selectedFacetsToAlgoliaEventFilter(selectedFacets)
    setAlgoliaQueryIDInLocalStorage(queryID)
    observer.next(
      AlgoliaEventActions.EVENT({
        eventName: 'select_filter',
        eventType: 'click',
        authenticatedUserToken: String(userID) || '',
        ...(eventFilters ? { filters: [eventFilters] } : { filters: ['none: none'] }),
        ...(queryID && {
          queryID: queryID,
        }), // pass queryID only if its present, otherwise do not pass
      })
    )
    observer.next(PageActions.IS_READY(true))
    observer.complete()
  }
)

export const algoliaEventEpic = observerEpicHelper(
  [AlgoliaActions.EVENT],
  async ({ action, observer, store }): Promise<void> => {
    const state = { ...store.value }
    const userToken = getAlgoliaUserToken(state)
    const searchIndice = getSortIndice(state)
    algoliaEventsApi({
      events: [
        {
          index: searchIndice,
          userToken,
          ...action.payload,
        },
      ],
    })
    observer.complete()
  }
)

export default [algoliaEventEpic, updateAlgoliaEpic]
